<template>
  <SoPageWithHeader title="Vouchers">
    <OpsReferralCodeSearch />
    <OpsReferralCodesBlacklistedTable />
    <OpsRecentReferralsTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import OpsReferralCodeSearch from "./components/OpsReferralCodeSearch.vue"
  import OpsReferralCodesBlacklistedTable from "./components/OpsReferralCodesBlacklistedTable.vue"
  import OpsRecentReferralsTable from "./components/OpsRecentReferralsTable.vue"

  export default defineComponent({
    components: {
      OpsReferralCodeSearch,
      OpsReferralCodesBlacklistedTable,
      OpsRecentReferralsTable,
      SoPageWithHeader,
    },
  })
</script>
